/* @refresh skip */
import { useAnnouncementUser } from "@/hooks/";
import { useMemo } from "react";
import { LAUNCH_DATE } from "@/config";

export function useIsKnownUser(address: string) {
    const { data: announcementUser, isLoading } = useAnnouncementUser(address);

    return useMemo(() => {
        if (isLoading) {
            return { isKnownUser: false, referralCode: null, isLoading: true };
        }

        if (!announcementUser) {
            return { isKnownUser: false, referralCode: null, isLoading: false };
        }

        const registrationTimestampMs = announcementUser.registrationTimestampMs;
        const registrationDate = new Date(registrationTimestampMs);
        const isKnown = registrationDate < LAUNCH_DATE || !!announcementUser.referrerCode;

        return { isKnownUser: isKnown, referralCode: announcementUser.referralCode, isLoading: false };
    }, [announcementUser, isLoading]);
}
